export const enum EnumTelaReceita {
    Receita = 1,
    Prescritor = 2,
    Comprador = 3,
    Paciente = 4,
    Medicamentos = 5,
}